var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtahCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 155,
    viewBox: "0 0 154 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23_63)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 64,
    r: 64,
    fill: "#07587F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_23_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2107 45.512L65.129 45.103L65.2107 45.0213L65.3744 45.2667L65.2107 45.512ZM68.6453 47.0656L67.991 45.921V44.6123L68.6453 45.839V47.0656ZM67.255 43.8764L66.601 43.3858L67.0096 43.2222L67.255 43.8764ZM55.152 33.1636L79.031 33.4089V45.512L97.513 45.2667L98.7397 93.9243L74.3696 94.3333L50 93.9243L51.7173 33L55.152 33.1636ZM62.3483 37.6613L60.8763 38.0702L61.2853 38.5609L60.8763 38.9698L61.5307 41.4231L60.8763 41.9956L61.2853 42.1591L61.8576 41.4231L62.512 42.1591L63.0843 43.2222L63.1663 45.4303L64.393 46.248L65.129 47.5563L65.6197 46.248L66.4373 49.1103L67.0096 49.3557L68.4816 48.2923L69.0543 47.0656L70.8533 45.921L69.2176 44.6944L67.8277 42.2409L67.255 42.1591L67.991 41.3413L69.2997 41.4231L69.7083 40.7689H67.664V40.1147L66.601 39.9511L67.0096 42.6498L66.3557 43.0587L65.5376 40.36L64.393 40.1964L63.575 39.3787L63.9024 37.6613L63.1663 37.0889L62.3483 37.6613Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23_63",
    x: 0.9,
    y: 0,
    width: 152.2,
    height: 154.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23_63"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23_63",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_23_63",
    x: 40.7,
    y: 28.7,
    width: 61.3397,
    height: 73.9335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23_63"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23_63",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtahCircle);
export default __webpack_public_path__ + "static/media/UtahCircle.474d11354cfa3350b548443bae4e1f64.svg";
export { ForwardRef as ReactComponent };